import { render, staticRenderFns } from "./PhaseTemplates.vue?vue&type=template&id=864a886e"
import script from "./PhaseTemplates.vue?vue&type=script&lang=js"
export * from "./PhaseTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports